var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIntegratedTruckingExp = function SvgIntegratedTruckingExp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#integrated-trucking-exp_svg__a)",
    d: "M30.033 46.667H6.667v6.666h23.366v10L43.333 50l-13.3-13.333zm19.934-3.334v-10h23.366v-6.666H49.967v-10L36.667 30z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "integrated-trucking-exp_svg__a",
    x1: -21.139,
    x2: 37.524,
    y1: -0.833,
    y2: 82.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BA4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14497B"
  })))));
};
export { SvgIntegratedTruckingExp as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAiIGhlaWdodD0iODAiIHZpZXdCb3g9IjAgMCA4MCA4MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMwLjAzMzQgNDYuNjY2Nkg2LjY2NjY5VjUzLjMzMzNIMzAuMDMzNFY2My4zMzMzTDQzLjMzMzQgNTBMMzAuMDMzNCAzNi42NjY2VjQ2LjY2NjZaTTQ5Ljk2NjcgNDMuMzMzM1YzMy4zMzMzSDczLjMzMzRWMjYuNjY2Nkg0OS45NjY3VjE2LjY2NjZMMzYuNjY2NyAzMEw0OS45NjY3IDQzLjMzMzNaIiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXJfMzk2XzI1NzMpIi8+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfMzk2XzI1NzMiIHgxPSItMjEuMTM4NiIgeTE9Ii0wLjgzMzM3MyIgeDI9IjM3LjUyNDIiIHkyPSI4Mi45NzA2IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiM1QkE0RUEiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMTQ0OTdCIi8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+Cg==";